import { ref, onBeforeUnmount } from 'vue'

interface IQueryParameter {
	key: string
	val: string
}
export default function useHashQuery() {
	// hashParameter and queryParameter for window.location.hash
	const hashParameter = ref<string[]>([])
	const queryParameter = ref<IQueryParameter[]>([])
	// searchParameter for window.location.search
	const searchParameter = ref<IQueryParameter[]>([])

	function getSearchUrl() {
		const { search } = window.location
		const searchString = search.replace('?', '')
		if (searchString === '' || searchString === '?') {
			return
		}

		searchParameter.value = searchString.split('&').map(string => {
			const [key, val = ''] = string.split('=')
			return { key, val }
		})
	}

	function spiltUrlHash() {
		const { hash } = window.location
		const [hashString, queryString] = hash.split('?')

		if (hashString !== undefined) {
			hashParameter.value = hashString
				.split('/')
				.filter(string => string !== '')
		} else {
			hashParameter.value = []
		}

		if (queryString !== undefined && queryString !== '') {
			queryParameter.value = queryString.split('&').map(string => {
				const [key, val = ''] = string.split('=')
				return { key, val }
			})
		} else {
			queryParameter.value = []
		}
	}

	function getHashRemoveQueryByKey(keyArray: string[] = []) {
		const hashString = hashParameter.value.join('/')
		const queryString = queryParameter.value
			.filter(query => keyArray.indexOf(query.key) === -1)
			.map(({ key, val }) => `${key}=${val}`)
			.join('&')
		const prefixQueryString = `?${queryString}`
		return `${hashString}${queryString === '' ? '' : prefixQueryString}`
	}

	function pushHashUrl(hash: string, isAutoAppendQuery = false) {
		if (isAutoAppendQuery === true) {
			hash = appendCurrentQueryString(hash)
		}

		window.location.hash = hash
	}

	function replaceHashUrl(hash: string, isAutoAppendQuery = false) {
		if (isAutoAppendQuery === true) {
			hash = appendCurrentQueryString(hash)
		}

		const href =
			window.location.hash === ''
				? `#${hash}`
				: window.location.href.replace(window.location.hash, `#${hash}`)
		if (isSupportPushState()) {
			window.history.replaceState('', '', href)
		} else {
			window.location.href = href
		}
	}

	function appendCurrentQueryString(hash: string) {
		if (queryParameter.value.length === 0) {
			return hash
		}

		const query = queryParameter.value
			.map(string => {
				if (string.val === '') {
					return string.key
				}

				return `${string.key}=${string.val}`
			})
			.join('&')

		return `${hash}?${query}`
	}

	function isSupportPushState() {
		return (() => {
			const ua = window.navigator.userAgent
			if (
				(ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) &&
				ua.indexOf('Mobile Safari') !== -1 &&
				ua.indexOf('Chrome') === -1 &&
				ua.indexOf('Windows Phone') === -1
			) {
				return false
			}

			return window.history && typeof window.history.pushState === 'function'
		})()
	}

	spiltUrlHash()
	getSearchUrl()
	window.addEventListener('hashchange', spiltUrlHash, false)
	window.onpopstate = spiltUrlHash

	onBeforeUnmount(() => {
		window.removeEventListener('hashchange', spiltUrlHash, false)
		window.onpopstate = null
	})

	return {
		hashParameter,
		queryParameter,
		searchParameter,
		getHashRemoveQueryByKey,
		pushHashUrl,
		replaceHashUrl,
	}
}
